import { EPaymentIntentStatus } from "features/common";
import { IPaymentIntentStatusWithProductResponse } from "../types";

export const mockGetPaymentIntentStatusWithProductResponse: IPaymentIntentStatusWithProductResponse = {
  result: {
    paymentIntentId: "pi_23",
    status: EPaymentIntentStatus.Succeeded,
    clientSecret: "cs_23",
    invoiceId: 123,
    product: {
      productId: 1,
      productNameShort: "Apple",
      productSiloId: 3,
      productSiloName: "Business"
    }
  },
  isSuccess: true,
  message: null,
  validationIssues: null
};
